<template>
  <v-container
    fluid
    class="ma-3"
  >
    <v-row v-if="topErrorMessage">
      <v-col>
        <v-row>
          <v-col
            class="text-center"
          >
            <span style="color:red; font-size: 1.5em">{{ topErrorMessage }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            class="text-center"
          >
            <v-btn
              color="success"
              x-large
              outlined
              @click="scanNewQrCode"
            >
              Scan new qr
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-container v-else-if="inventoryTag">
      <v-row
        class="pr-6"
      >
        <v-col
          cols="4"
          class="align-center pb-0"
          style="justify-content: center; display: flex;"
        >
          <v-img
            :src="convertedPhoto(inventoryTag.item.photo, inventoryTag.item.mime_type)"
            contain
            height="100%"
            width="100%"
            class="profile-photo"
          />
        </v-col>
        <v-col
          cols="8"
          class="pb-0"
        >
          <v-row
            style=""
            class="align-center pt-1 pb-1"
          >
            <v-col cols="6">
              <v-row class="align-center">
                <v-col cols="4">
                  <span style="font-size: 30px; font-weight: 500;">QR Code: </span>
                </v-col>
                <v-col>
                  <span style="font-size: 30px; font-weight: 600;">{{ inventoryTag.inventory_tag }}</span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row class="align-center">
                <v-col cols="4">
                  <span style="font-size: 30px; font-weight: 500;">Class:</span>
                </v-col>
                <v-col>
                  <v-chip
                    class="mt-1 mb-1"
                    text-color="white"
                    :color="inventoryTag && inventoryTag.item && inventoryTag.item.classes ? inventoryTag.item.classes.color : 'white'"
                  >
                    <span style="font-size: 20px; color: #fff !important;">{{ inventoryTag && inventoryTag.item && inventoryTag.item.classes ? inventoryTag.item.classes.name : '-' }}</span>
                  </v-chip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row
            style="background-color: #F5F5F5; border-radius: 6px;"
            class="align-center pt-1 pb-1"
          >
            <v-col cols="6">
              <v-row class="align-center">
                <v-col cols="4">
                  <span class="desc-span">Inventory Item:</span>
                </v-col>
                <v-col>
                  <span class="main-span">{{ inventoryTag ? inventoryTag.item_full_name : '' }}</span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row class="align-center">
                <v-col cols="4">
                  <span class="desc-span">Color:</span>
                </v-col>
                <v-col>
                  <span class="main-span">{{ inventoryTag ? inventoryTag.color_code : '' }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row
            style=""
            class="align-center pt-1 pb-1"
          >
            <v-col v-if="inventoryTag && inventoryTag.inventory_class_id !== inventoryClassIdPanels" cols="6">
              <v-row class="align-center">
                <v-col cols="4">
                  <span class="desc-span">Length:</span>
                </v-col>
                <v-col>
                  <span class="main-span">{{ inventoryTag ? inventoryTag.length_name : '' }}</span>
                </v-col>
              </v-row>
            </v-col>
            <v-col v-if="inventoryTag && inventoryTag.inventory_class_id === inventoryClassIdPanels" cols="6">
              <v-row class="align-center">
                <v-col cols="4">
                  <span class="desc-span">Dimension Unit:</span>
                </v-col>
                <v-col>
                  <span class="main-span">{{ inventoryTag && inventoryTag.dimension_unit ? inventoryTag.dimension_unit.name : '' }}</span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row class="align-center">
                <v-col cols="4">
                  <span class="desc-span">UOM:</span>
                </v-col>
                <v-col>
                  <span class="main-span">{{ inventoryTag ? inventoryTag.uom_name : '' }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row
            style="background-color: #F5F5F5; border-radius: 6px;"
            class="align-center pt-1 pb-1"
          >
            <v-col cols="6">
              <v-row class="align-center">
                <v-col cols="4">
                  <span class="desc-span">Location:</span>
                </v-col>
                <v-col>
                  <span class="main-span">{{ inventoryTag ? inventoryTag.location_name : '' }}</span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row class="align-center">
                <v-col cols="4">
                  <span class="desc-span">Shelf:</span>
                </v-col>
                <v-col>
                  <span class="main-span">{{ inventoryTag ? inventoryTag.inventory_location_name : '' }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="pr-6">
        <v-col cols="4">
          <v-row class="align-center text-center">
            <v-col>
              <span style="font-size: 42px; font-weight: 500;">Qty On Hand: </span><span style="font-size: 42px; font-weight: 600;">{{ inventoryTag.quantity_on_hand }}</span>
              <div v-if="allocationIsEnabled" style="font-size: 30px;">
                  Total Qty Allocated: {{ totalAllocated }}
              </div>
              <div v-if="allocationIsEnabled && allocationDataMap[form.job_id || ''] && Number(allocationDataMap[form.job_id].qty) > 0" style="font-size: 20px;">
                  Qty Allocated to this job: {{ Number(allocationDataMap[form.job_id].qty) }}
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="8">
          <v-form
            ref="form"
          >
            <v-row>
              <v-col class="pl-0 pr-0 pb-6">
                <v-radio-group
                  v-model="recordTypeId"
                  hide-details
                  dense
                  row
                >
                  <v-radio
                    :value="0"
                    small
                    class="mr-10"
                  >
                    <template slot="label">
                      <v-chip
                        class="mt-1 mb-1"
                        text-color="white"
                        color="#BF0000"
                      >
                        <span style="font-size: 20px; color: #fff !important;">Supply Record</span>
                      </v-chip>
                    </template>
                  </v-radio>
                  <v-radio
                    :value="1"
                    small
                    class="mr-10"
                  >
                    <template slot="label">
                      <v-chip
                        class="mt-1 mb-1"
                        text-color="white"
                        color="#3BA424"
                      >
                        <span style="font-size: 20px; color: #fff !important;">Return Record</span>
                      </v-chip>
                    </template>
                  </v-radio>
                  <v-radio
                    :value="2"
                    small
                  >
                    <template slot="label">
                      <v-chip
                        class="mt-1 mb-1"
                        text-color="white"
                        color="#FF8C00"
                      >
                        <span style="font-size: 20px; color: #fff !important;">Scrap Record</span>
                      </v-chip>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row v-if="recordTypeId == 2">
              <v-col class="pl-0 pr-0 pt-0 pb-0">
                <v-select
                  v-model="form.scrap_reason_id"
                  :items="scrapReasons"
                  item-text="name"
                  item-value="id"
                  filled
                  clearable
                  :rules="[(v) => !!v || 'Reason is required']"
                >
                  <template slot="label">
                    Reason<RedAsterisk />
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pl-0 pr-0 pt-0 pb-0">
                <v-autocomplete
                  v-model="form.job_id"
                  :label="businessRulesGetBoolean('Jobs Rename to Release') ? 'Release' : 'Job'"
                  :items="jobs"
                  :item-text="item => `${item.code} - ${item.name}; ${item.reference}`"
                  item-value="id"
                  clearable
                  :rules="[(v) => !!v || 'Job is required']"
                  filled
                  :loading="loadingJobs"
                >
                  <template #selection="{ item }">
                    <span>
                      <span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span>
                    </span>
                  </template>

                  <template #item="{ item }">
                    <span>
                      <span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }}<span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span>
                    </span>
                  </template>
                  <template slot="label">
                    {{ jobLabel }}<RedAsterisk />
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pl-0 pr-0 pt-0 pb-0">
                <v-text-field
                  v-model="form.quantity_supplied"
                  :rules="[(v) => !!v || 'Quantity is required']"
                  type="number"
                  filled
                >
                  <template slot="label">
                    Quantity<RedAsterisk />
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pl-0 pr-0 pt-0 pb-0">
                <v-textarea
                  v-model="form.note"
                  filled
                  label="Note"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
      <v-row class="mr-1">
        <v-spacer />
        <v-col cols="auto">
          <v-btn
            color="normal"
            class="mr-3"
            x-large
            @click="cancel"
          >
            Cancel
          </v-btn>
          <v-btn
            outlined
            color="primary"
            class="mr-3"
            x-large
            :loading="loadingSubmit"
            @click="reprint"
          >
            REPRINT
          </v-btn>
          <v-btn
            color="primary"
            x-large
            :loading="loadingSubmit"
            @click="submit"
          >
            SUBMIT
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { getInventoryTagAllocations, jobCanBeSupplied } from '../../api/InventoryAllocationApi';
import { store } from '../../api/RecordsApi';

export default {
  components: {

  },
  props: {

  },
  data: () => ({
    qrCode: null,
    topErrorMessage: null,
    inventoryTag: null,
    jobs: [],
    form: {
      quantity_supplied: null,
      quantity_missed: null,
      is_return: 0,
      is_scrap: 0,
      scrap_reason_id: null,
      job_id: null,
      note: null
    },

    inventoryClassIdPanels: 8,
    inventoryClassIdMaintenance: 21,
    recordTypeId: 0,

    loadingJobs: false,
    scrapReasons: [],
    loadingSubmit: false,
    allocationDataMap: {},
  }),
  computed: {
    jobLabel() {
      return this.$store.getters['businessRulesGetBoolean']('Jobs Rename to Release')
        ? 'Release'
        : 'Job'; 
    },
    totalAllocated() {
      if (!this.allocationIsEnabled) return 0;
      return Object.keys(this.allocationDataMap).reduce((acc, key) => acc += Number(this.allocationDataMap[key].qty), 0);
    },
    ...mapState({

    }),
    ...mapGetters([
      'isPhysicalCountActivated',
      'currentPhysicalCount',
      'businessRulesGetBoolean',
      'getAdminModuleValue',
    ]),
    allocationIsEnabled() {
      return this.getAdminModuleValue('Inventory Allocation')
    }
  },
  watch: {
    recordTypeId() {
      if (this.recordTypeId === 2) {
        this.form.scrap_reason_id = null;
      }
    },
  },
  created() {
    this.init();
  },

  mounted() {
    this.upsertSTLBlob();
  },

  methods: {
    init() {
      this.qrCode = this.$route.params.code;

      this.getInventoryTag();
      this.getInventoryItems();

      if (this.allocationIsEnabled) getInventoryTagAllocations(this.qrCode).then(res => {
        this.allocationDataMap = res.reduce((acc, x) => {
          if (!(x.job_id in acc)) acc[x.job_id] = x;
          else acc[x.job_id].qty += x.qty;
          return acc;
        }, {});
      });
    },

    scanNewQrCode() {
      this.$router.push('/stl-qr');
    },

    async reprint() {
      try {
        const id = this.$route.params.id || this.$route.params.code;
        if (!id) {
          console.warn('[reprint] No stl_id in route params');
          return;
        }
        this.$bus.$emit('loading');
        const webhookData = {
          module_id: 9,
          // stl_id: Number(id),
          inventory_tag_id: Number(id),
          quantity: this.form.quantity_supplied,
        };
        const res = await this.$api.webhook.store(
          webhookData,
          'run-download',
          { responseType: 'blob' }
        );
        if (!res) {
          this.$bus.$emit('showError', 'Failed to generate PDF');
          return;
        }
        const blob = res instanceof Blob ? res : (res.data instanceof Blob ? res.data : new Blob([res], { type: 'application/pdf' }));
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `stl_${id}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      } catch (e) {
        console.error('[reprint] Error:', e);
        this.$bus.$emit('showError', 'Error generating PDF');
      } finally {
        this.$bus.$emit('loading-stop');
      }
    },

    getSelectedInventoryItemName() {
      const selectedId = this.inventoryTag?.inventory_item_id;
      if (!selectedId) return null;
      const targetId = Number(selectedId);
      const fromList = (this.inventoryItems || []).find(i => Number(i.id) === targetId);
      return fromList?.name || this.inventoryTag?.item?.name || null;
    },
    
    async upsertSTLBlob() {
      try {
        const id = this.$route.params.id || this.$route.params.code;
        if (!id) {
          console.warn('[stl_blob/upsert] No id in route params');
          return;
        }
        const text = window.location.href;
        if (!this.inventoryTag) await this.getInventoryTag();
        if (!this.inventoryItems?.length) await this.getInventoryItems();
        const name = this.getSelectedInventoryItemName() || `QR ${id}`;
        const res = await this.$api.stlBlob.store({ id, text, name });
        if (!res || res.err) {
          console.log('[stl_blob/upsert] Error:', res);
          // this.$bus?.$emit?.('showError', res?.errDesc || 'Failed to generate QR.');
          return;
        }
        console.log('[stl_blob/upsert] Success:', res);
      } catch (e) {
        console.error('[stl_blob/upsert] Error:', e);
        this.$bus?.$emit?.('showError', 'Unexpected error while generating QR.');
      }
    },

    async getInventoryItems() {
      const readModel = {
        filters:
        {
          inventory_class_id: this.inventoryClassId,
        },
      };

      const res = await this.$api.inventoryItem.readData(readModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || !res.data || res.data.length === 0) {
        this.inventoryItems = [];
        return;
      }
      this.inventoryItems = res.data;
    },

    async getInventoryTag() {
      const submitModel = {
        filters: {
          inventory_tag: this.qrCode,
          is_qty_on_hand_o: 0,
        },
        includes: {
          is_include_item_image: true,
          is_include_supplier_label: true,
        },
      };

      const res = await this.$api.inventoryTag.read(submitModel);

      if (!res || !res.data || !res.data[0]) {
        this.inventoryTag = null;
        this.topErrorMessage = 'QR Code not found';
        return;
      }

      const firstIndex = 0;
      let data = res.data[firstIndex];

      if (data.inventory_class_id !== null && data.inventory_class_id === this.inventoryClassIdMaintenance) {
        this.inventoryTag = null;
        this.topErrorMessage = 'QR Code belongs to Maintenance Class and cannot be used in Supply To Line';
        return;
      }

      if (this.isPhysicalCountActivated && this.currentPhysicalCount && this.currentPhysicalCount.classes && this.currentPhysicalCount.classes.some((c) => c.id === data.item.inventory_class_id)) {
        //get the physical count record 
        const submitModel2 = {
          filters: {
            inventory_tag: this.qrCode,
            physical_count_list_id: this.currentPhysicalCount.id,
          },
        }
        const res2 = await this.$api.physicalCount.read(submitModel2);
        if (res2 && res2.data && res2.data[0]) {
          data = res2.data[0];
          data.quantity_on_hand = data.quantity;
        }
      }

      this.inventoryTag = data;

      this.getJobs();
      this.getScrapReasons();
    },

    async getJobs() {
      this.loadingJobs = true;
      const readModel = {
        filters:
        {
          // inventory_class_id: this.inventoryTag.item.inventory_class_id,
        },
        sort: {
          order_by_first: 'id',
          direction_sort: 0,
        },
      };
      this.jobs = await this.$api.job.readDDL(readModel);
      this.loadingJobs = false;
    },

    async getScrapReasons() {
      this.scrapReasons = await this.$api.supplyToLineScrapReason.get();
    },

    async submit() {
      if (!await this.$refs.form.validate()) return;
      const qtyOnHand = Number(this.inventoryTag.quantity_on_hand);
      const qtyAllocated = Number(this.totalAllocated);
      const qtyAllocatedToThisJob =  this.allocationDataMap[this.form.job_id]?.qty ?? 0;

      const qtyAvailable = qtyOnHand - (qtyAllocated - qtyAllocatedToThisJob);
      const isReturn = this.recordTypeId === 1 ? 1 : 0;
      if (parseInt(this.form.quantity_supplied, 10) > qtyAvailable && !isReturn) {
        this.$bus.$emit('showError', 'The supplied quantity cannot exceed the available quantity');
        return;
      }
      this.loadingSubmit = true;
      const canSupply = !this.allocationIsEnabled || await jobCanBeSupplied(this.form.job_id);
      if (!canSupply) {
        this.$bus.$emit('showError', 'Cannot supply to line for this job. Associated Allocation is not issued');
        this.loadingSubmit = false;
        return;
      }

      const submitModel = {
        job_id: this.form.job_id,
        quantity_supplied: this.form.quantity_supplied,
        quantity_missed: 0,
        is_return: isReturn,
        is_scrap: this.recordTypeId === 2 ? 1 : 0,
        inventory_item_id: this.inventoryTag.item.id,
        inventory_tag: this.inventoryTag.inventory_tag,
        scrap_reason_id: this.form.scrap_reason_id,
        inventory_class_id: this.inventoryTag.item.inventory_class_id,
        inventory_allocation_item_id: this.allocationIsEnabled ? this.allocationDataMap[this.form.job_id]?.allocation_item_id ?? null : null,
        note: this.form.note
      };

      try {
        await store(submitModel);
        this.$bus.$emit('showSuccess');
        this.$router.push('/stl-qr');
      } catch (e) {
        console.error(e);
        this.$bus.$emit('showError', `Failed to supply to line. ${e.response?.data ?? ''}`);
      } finally {
        this.loadingSubmit = false;
      }
    },

    convertedPhoto(photo, mimeType) {
      if (!photo) return '';
      return `data:${mimeType};base64, ${photo}`;
    },

    cancel() {
      this.$router.push('/stl-qr');
    },
  },
};
</script>

<style scoped>
.desc-span {
  font-size: 16px;
  color: rgba(0,0,0,0.6);
  font-weight: 500;
}
.main-span {
  font-size: 16px;
  font-weight: 600;
}

.profile-photo{
  max-width: 350px;
  max-height: 350px;
}
</style>
